<template>
  <div>
    <b-modal id="modal-sm" size="md" v-model="loading" no-close-on-esc no-close-on-backdrop hide-header-close hide-footer>
        <div slot="default">
        <div class='alert alert-danger' role='alert' > Loading service codes, please wait.... <br>  </div>
       <div class="text-center justify-content-center row col-12">
            <ring-loader class="text-center justify-content-center" :color="color" :loading="loading" :size="Ringsize" :sizeUnit="unit"></ring-loader> 
            <rise-loader class="text-center justify-content-center" :color="color" :loading="loading" :size="Risesize" :sizeUnit="unit"></rise-loader> 
            <ring-loader class="text-center justify-content-center" :color="color" :loading="loading" :size="Ringsize" :sizeUnit="unit"></ring-loader> 
        </div>          
        </div>  
    </b-modal>
    <b-modal
      id="modal-sm"
      size="md"
      title="Service Code"
      v-model="showModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <div slot="default">
        <div class="alert alert-warning" role="alert" v-if="!succeeded">
          {{ Msg }} <br />
          Please Contact System Administrator.
        </div>
        <div class="alert alert-success" role="alert" v-if="succeeded">
          {{ Msg }}
        </div>
      </div>
      <div slot="modal-footer" class="w-100">
        <p class="float-left" variant="primary"></p>
        <b-button
          variant="primary"
          size="md"
          class="float-right"
          @click="PopMsgClose"
        >
          Close
        </b-button>
      </div>
    </b-modal>
     <!-- @input="ScChange" -->
    <form>
      <div class="form-group row">
        <div class="col-sm-12 form-control-xs">
          <vue-bootstrap-typeahead
            ref="searchbox"
            @input="ScChange"
            v-model="ServiceCodeInput"
            :data="ServiceCodes"
            @hit="SelectedCode = $event"
            :serializer="(item) => item.servicedesc  + ' ( Effective Date: ' + item.eff + ', Expiry Date: '+item.exp+')'"
            textVariant=".text-info"
            placeholder="Search Service Code"
            size="sm"
            backgroundVariant="bg-light"
            :maxMatches="20" :disableSort=true
          >
            <template slot="prepend">
              <span class="input-group-text" style="font-size: 0.7rem"
                ><i class="fas fa-search fa-sm"></i
              ></span>
            </template>
          </vue-bootstrap-typeahead>
        </div>
      </div>
      <div class="form-group row my-1">
        <label for="CodeID" class="col-sm-4 label-small my-0"
          >Service Code:</label
        >
        <div class="col-sm-4 my-0">
          <input
            id="CodeID"
            v-model="SelectedCode.servicecode"
            readonly
            placeholder="Service Code ID"
            class="form-control form-control-xs my-0 mb-0"
          />
        </div>
        <div
          :class="{ 'col-sm-4 my-0': $v.SelectedCode.$error }"
          v-show="$v.SelectedCode.$error"
        >
          <div class="row">
            <small class="sml-red" v-if="!$v.SelectedCode.required"
              >Service code is required.
            </small>
          </div>
        </div>
      </div>
      <div class="form-group row my-1">
        <label for="Fee" class="col-sm-4 label-small my-0"
          >Service Amount:</label
        >
        <div class="col-sm-4 my-0">
          <input
            id="Fee"
            v-model="ServiceFee"
            placeholder="Service Amount"
            class="my-0 form-control form-control-xs"
          />
        </div>
        <div
          :class="{ 'col-sm-4 my-0': $v.ServiceFee.$error }"
          v-show="$v.ServiceFee.$error"
        >
          <div class="row">
            <small class="sml-red" v-if="!$v.ServiceFee.required"
              >Service Amount is required.</small
            >
            <small class="sml-red" v-if="!$v.ServiceFee.fee"
              >must be a valid amount.</small
            >
          </div>
        </div>
      </div>

      <!-- <div class="form-group row my-0 mb-0 mt-1" v-if="ClaimTypeID == 1">
        <label for="inputEmail3" class="col-sm-4 label-small mb-0"
          >Prior Approval #:</label
        >
        <div class="col-sm-4">
          <input
            id="pa"
            type="text"
            v-model="PriorApprovalNo"
            placeholder="Prior Approval #"
            class="my-0 form-control form-control-xs"
          />
        </div>
        <div class="col-sm-4 mb-0" v-show="$v.PriorApprovalNo.$error">
          <div class="row mb-0">
            <small class="sml-red" v-if="!$v.PriorApprovalNo.numeric">must be a number.</small>
            <small class="sml-red" v-if="!$v.PriorApprovalNo.Panumber"
              >must be a valid number.</small
            >
          </div>
        </div>
      </div> -->

      <div class="form-group row my-1">
        <label for="Qty" class="col-sm-4 label-small">Qty:</label>
        <div class="col-sm-4">
          <input
            id="Qty"
            type="number"
            min="1"
            max="999"
            v-model.number="Qty"
            maxlength="3"
            placeholder="Qty"
            class="my-0 form-control form-control-xs"
          />
        </div>
        <div :class="{ 'col-sm-4 mb-0': $v.Qty.$error }" v-show="$v.Qty.$error">
          <div class="row">
            <small class="sml-red" v-if="!$v.Qty.required"
              >Qty is required.</small
            >
            <small class="sml-red" v-if="!$v.Qty.val"
              >must be a valid qty.</small
            >
            <small class="sml-red" v-if="!$v.Qty.numeric"
              >must be a number.</small
            >
          </div>
        </div>
      </div>

      <div class="form-group row my-1">
        <label for="third" class="col-sm-4 label-small"
          >1st Payer Paid Amount (if applicable):</label
        >
        <div class="col-sm-4">
          <input
            id="third"
            type="text"
            v-model="ThirdPartyAmt"
            placeholder="1st Payer Paid Amount"
            class="my-0 form-control form-control-xs"
          />
        </div>
        <div class="col-sm-4 mb-0" v-show="$v.ThirdPartyAmt.$error">
          <div class="row">
            <small class="sml-red" v-if="!$v.ThirdPartyAmt.fee"
              >must be a valid amount.</small
            >
          </div>
        </div>
      </div>
      <div
        class="form-group row my-1"
        v-if="this.SelectedClaimStatusID === 4 && this.ClaimInfo.CanOverride"
      >
        <label for="third" class="col-sm-4 label-small">Total Paid</label>
        <div class="col-sm-4">
          <input
            id="dpamt"
            type="text"
            v-model="AssessedAmt"
            placeholder="Total Paid"
            class="my-0 form-control form-control-xs"
          />
        </div>
        <div class="col-sm-4 mb-0" v-show="$v.AssessedAmt.$error">
          <div class="row">
            <small class="sml-red" v-if="!$v.AssessedAmt.fee"
              >must be a valid amount.</small
            >
            <small class="sml-red" v-if="!$v.AssessedAmt.val"
              >enter a valid amount.</small
            >
          </div>
        </div>
      </div>

      <div
        class="form-group row my-1"
        v-if="SelectedClaimStatusID == 4 && ClaimTypeID == 2"
      >
        <label for="Tooth1" class="col-sm-4 label-small">Expiry Date:</label>
        <div class="col-sm-4">
          <div>
            <datepicker
              typeable
              :open-date="new Date()"
              v-model="ExpiryDate"
              :format="dateFormat"
              id="exp"
              :bootstrap-styling="true"
              :input-class="datapickClass"
              name="expirydatepicker"
            ></datepicker>
          </div>
        </div>
        <!-- <div  :class="{ 'col-sm-4 mb-0': $v.Qty.$error}"   v-show="$v.Qty.$error">
      <div class="row">
        <small class="sml-red" v-if="!$v.Qty.required">Confirm Password is required.</small>
        </div>
    
    </div> -->
      </div>

      <div class="form-group row my-1">
        <label for="Tooth1" class="col-sm-4 label-small">Tooth No1:</label>
        <div class="col-sm-4">
          <input
            id="Tooth1"
            type="text"
            v-model.number="Tooth1"
            placeholder="Tooth No1"
            class="my-0 form-control form-control-xs"
          />
        </div>
        <div
          :class="{ 'col-sm-4 mb-0': $v.Tooth1.$error }"
          v-show="$v.Qty.$error"
        >
          <div class="row">
            <small class="sml-red" v-if="!$v.Tooth1.needValue"
              >Must enter tooth1 before tooth2 or comments</small
            >
            <small class="sml-red" v-if="!$v.Tooth1.val"
              >must be a valid no.</small
            >
          </div>
        </div>
      </div>

      <div class="form-group row my-1">
        <label for="Tooth2" class="col-sm-4 label-small">Tooth No2:</label>
        <div class="col-sm-4">
          <input
            id="Tooth2"
            type="text"
            v-model.number="Tooth2"
            placeholder="Tooth No2"
            class="my-0 form-control form-control-xs"
          />
        </div>
        <div class="col-sm-4 mb-0" v-show="$v.Tooth2.$error">
          <div class="row">
            <small class="sml-red" v-if="!$v.Tooth2.needValue"
              >Tooth2 can't be same as Tooth1</small
            >
          </div>
          <div class="row">
            <small class="sml-red" v-if="!$v.Tooth2.T1Check"
              >Must enter Tooth1 first.</small
            >
            <small class="sml-red" v-if="!$v.Tooth2.val"
              >must be a valid no.</small
            >
          </div>
        </div>
      </div>

      <div class="form-group row my-1">
        <label for="Comments" class="col-sm-4 label-small">Comments:</label>
        <div class="col-sm-4">
          <textarea
            wrap="on"
            rows="2"
            max="42"
            id="Comments"
            type="textarea"
            v-model="Comments"
            placeholder="Add Additional Tooth no's here."
            class="my-0 form-control text-area-xs"
          ></textarea>
        </div>
        <div class="col-sm-4 mb-0" v-show="$v.Comments.$error">
          <div class="row">
            <small class="sml-red" v-if="!$v.Comments.needValue"
              >Enter value in tooth1 and tooth2 first.</small
            >
            <small class="sml-red" v-if="!$v.Comments.commentsReg"
              >Invalid format.</small
            >
          </div>
        </div>
      </div>

      <div class="form-group row my-1">
        <label for="Comments" class="col-sm-4 label-small"></label>
        <div class="col-sm-8">
          <div class="row ml-0">
            <small class="sml-red"
              ><b>Note:</b> For more than two teeth no please add those in the
              comments box. Using <strong> Format: 16,18,19</strong></small
            >
          </div>
        </div>
      </div>

 <!-- {{SelectedCode}} -->
 <!-- {{ServiceCodeInput}} -->
 <!-- {{PriorApprovalNo}}
 {{HSN}}
 {{ClinicNo}}
 {{ProviderNo}} (pas.length) &&  -->

 
        <div class="form-group row my-1" v-if="btnFindShow && ClaimTypeID==1">
      <!-- <div class="form-group row my-1" v-if="(PriorApprovalNo !='') && (HSN !='') && (ClinicNo !='') && (ProviderNo !='') && (SelectedCode !=null && SelectedCode !='')"> -->
       
        <label for="Comments" class="col-sm-4 label-small"></label>
        <div class="col-sm-4">
         <button   v-on:click="GetPriorAprovals(2)"   type="button"  class="btn BtnClose btn-sml float-left">
          <i class="fa fa-search" aria-hidden="true"></i>Find Prior Approvals
        </button>
        </div>
        <div class="col-sm-4 mb-0"> 
        </div>
      </div>

        <div class="form-group row my-1" v-if="btnFindShow && ClaimTypeID==1">
        <label for="Comments" class="col-sm-4 label-small"></label>
        <div class="col-sm-8">
          <div class="row ml-0">
            <small class="sml-red"
              ><b>Note:</b><strong> To find prior approvals please make sure you enter correct information for tooth numbers.</strong></small
            >
          </div>
        </div>
      </div>
   <div class="form-group row my-0 mb-0" v-if="ClaimTypeID == 1">
        <label v-if="pas.length" for="pa" class="col-sm-4 label-small mb-0"
          >Select Prior Approval #:</label
        >
        <label v-else for="pa" class="col-sm-4 label-small mb-0"
          ></label
        >   
        <div class="col-sm-4" v-if="pas.length">
        <select v-model="PriorApprovalNo"  class="form-control form-control-sm" >
        <option v-for="option in pas" v-bind:value="option.value"  :key="option.value"> 
          {{ option.key }}
        </option>
        </select> 
          <!-- <input
            id="pa"
            type="text"
            v-model="PriorApprovalNo"
            placeholder="Prior Approval #"
            class="my-0 form-control form-control-xs"
          /> -->
        </div>
       <div v-else class="col-sm-4">
          <h6>
          <small class="text-muted red"
            ><b>{{PaMsg}}</b></small
          >
        </h6>         
         </div>
        <div class="col-sm-4 mb-0" v-show="$v.PriorApprovalNo.$error">
          <div class="row mb-0">
            <!-- <small class="sml-red" v-if="!$v.PriorApprovalNo.numeric">must be a number.</small> -->
            <small class="sml-red" v-if="!$v.PriorApprovalNo.Panumber"
              >must be a valid number.</small
            >
          </div>
        </div>
      </div>

    <!-- <div class="form-group row my-0 mb-0 mt-1" v-if="ClaimTypeID == 1">
        <label for="inputEmail3" class="col-sm-4 label-small mb-0"
          >Prior Approval #:</label
        >
        <div class="col-sm-4">
          <input
            id="pa"
            type="text"
            v-model="PriorApprovalNo"
            placeholder="Prior Approval #"
            class="my-0 form-control form-control-xs"
          />
        </div>
        <div class="col-sm-4 mb-0" v-show="$v.PriorApprovalNo.$error">
          <div class="row mb-0">
            <small class="sml-red" v-if="!$v.PriorApprovalNo.Panumber"
              >must be a valid number.</small
            >
          </div>
        </div>
      </div> -->


    </form>

    <h6>
      <small class="text-muted"
        ><b>{{ Note }}</b></small
      >
    </h6>
    <hr />
    <div class="row">
      <div class="col-sm-6">
        <button
          v-on:click="AddEditPA"
          type="button"
          class="btn BtnSave btn-sml"
        >
          <i :class="saveIcon"></i> {{ btnName }}
        </button>
      </div>
      <!-- {{adduser}} -->
      <div class="col-sm-6">
        <button
          :disabled="(btnName =='Add Service Code' && totalScodes == 40)? true : false"
          v-on:click="Exit"
          type="button"
          class="btn BtnClose btn-sml float-right"
        >
          <i class="fas fa-times"></i> Close Form
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";
import Vuelidate from "vuelidate";
import { helpers } from "vuelidate/lib/validators";
//import vselect from 'vue-select'
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import { RingLoader } from '@saeris/vue-spinners';
import { RiseLoader } from '@saeris/vue-spinners';
import {
  required,
  minLength,
  sameAs,
  not,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
import { notEqual } from "assert";
import { constants } from "fs";
const Panumber = helpers.regex("Panumber", /^([0-9]{21})$/);
const qtyreg = helpers.regex("qtyreg", /^[0-9]{2}$/);
//const fee = helpers.regex('fee',  /^\d+(\.\d{1,2})?$/);

const fee = helpers.regex("fee", /^[0-9]{0,6}(\.[0-9]{1,2})?$/);
const commentsReg = helpers.regex("commentsReg", /^[1-9]\d(?:,[1-9]\d){0,2}$/);
//^([0-9]{15}|9)$/
Vue.use(Vuelidate);

export default {
  props: { ClaimInfo: { type: Object }, ServiceCodeInfo: { type: Object } },
  data: function () {
    return {
      loading:false,
      counter: 0,
      size: 150,
      Ringsize: 30,
      Risesize: 12,
      margin :'2px',
      unit: 'px',
      color:'#bada55',
      PaMsg:'',
      pas:[],
      totalScodes: "",
      btnFindShow: false, 
      saveIcon: "fas fa-plus",
      btnName: "Add Service Code",
      Note: "Note: You can add one or more Service Codes using the Add button below. You must add at least one service code to proceed.",
      ClaimStatusId: "",
      ServiceCodeInput: "",
      SelectedClaimStatusID: "",
      calendarwidth: "50px",
      ClaimRequestNo: null,
      ClaimTypeID: "",
      HSN: "",
      PriorApprovalNo: null,
      ProviderNo: "",
      ClinicNo: "",
      ServiceCode: "",
      ServiceCodeId: null,
      ServiceFee: "",
      ServiceDate: "",
      ExpiryDate: null,
      Qty: "",
      Tooth1: null,
      Tooth2: null,
      ThirdPartyAmt: null,
      AssessedAmt: null,
      Comments: "",
      SelectedCode: "",
      AppServiceID: 1,
      ServiceCodes: [],
      datapickClass: "form-control form-control-xs my-0",
      updateMessage: "",
      showUpdate: true,
      activeColor: "red",
      fontSize: 30,
      exit: "",
      dateFormat: "",
      succeeded: false,
      Msg: "",
      showModal: false,
    };
  },
  components: {
    Datepicker,
            RingLoader,
        RiseLoader
  },
  filters: {
    moment: function (date) {
      return moment(date, "YYYY-MM-DD").format("YYYY/MM/DD");
    },
    stringify(value) {
      return JSON.stringify(value, null, 2);
    },
  },
  watch: {
    SelectedCode:function(){
      if(this.SelectedCode !=null && this.SelectedCode !='')
      {
        //this.GetPriorAprovals();
        this.btnFindShow =true;
        //console.log(' SC = ' + this.SelectedCode.servicecode)
      }
      else
      {
        this.pas= [];
        this.btnFindShow =false;
        this.PriorApprovalNo='';
      }
    },
    totalScodes : function () { 
      console.log(this.totalScodes)
      if(this.btnName =='Add Service Code' && this.totalScodes == 40)
      {
        this.showMsg("The number of service codes entered is greater than the maximum allowed.","","Service Code Error")
      }
    },
    },
  methods: {
        showMsg(msg, data, Title) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxOk(msg, {
          title: Title,
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Close",
          footerClass: "p-2",
          hideHeaderClose: true,
          hideHeaderCancel: true,
          centered: true,
        })
        .then((value) => {
          console.log("at value " + value);
          this.boxTwo = value;
          if (value) {
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    GetPriorAprovals: function (val) {
      this.pas  = [];
      this.PaMsg = '';
      var t1,t2;
      if(this.Tooth1 ==null)
      t1="00"
      else t1=this.Tooth1
      if(this.Tooth2 ==null)
      t2="00"
      else
      t2 = this.Tooth2;
      var vm = this;
      var params = new URLSearchParams();   
      params.append("HSN", this.HSN);
      params.append("ServiceType", "DEN");
      params.append("Clinic", this.ClinicNo);
      params.append("Provider", this.ProviderNo);
      params.append("serviceCode", this.SelectedCode.servicecode);
      params.append("tooth1", t1);
      params.append("tooth2", t2);

      //GetPAs(string HSN, string ServiceType, string Clinic, string Provider, string serviceCode, string tooth1, string tooth2)
      axios
        .get("SaskHealthApi/Host/GetPAs", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          vm.pas = response.data;
          //vm.pas.sort();
        })
        .catch(function (er) {
            if(er.response.status ==400)
            {
                vm.showMsg("Please make sure you enter correct information for tooth numbers.","","No prior approval found")
            }
            else if(er.response.status == 500)
            { //Network Error, please contact system admin for more detail.
                vm.showMsg("Network Error, please contact system admin for more detail.","","No prior approval found")
            }
        })
        .then(function () { 
          if (vm.pas.length)
          {
            if(val == 2)
            {
              vm.PriorApprovalNo = "";
            }
          }
        });
    },

    ScChange() {
      console.log(" SC input = " + this.ServiceCodeInput);
      if (this.ServiceCodeInput == "" || this.ServiceCodeInput == null)
        // this.SelectedCode.servicedesc == null){
        //console.log(this.SelectedCode)
        this.SelectedCode = '';
        this.btnFindShow =false;
    },
    PopMsgClose() {
      if (this.succeeded) {
        this.ClrForm();
        this.showModal = false;
        if (this.ServiceCodeId != null && this.ServiceCodeId != undefined) {
          this.Exit();
        }
      } else {
        //this.ClrForm();
        this.showModal = false;
      }
    },
    ClrForm: function () {
      //this.$forceUpdate();
      //this.searchbox.value = '';
      this.ServiceCode = "";
      //this.ServiceCodeId ='';
      this.ServiceFee = "";
      this.ServiceDate = "";
      this.Qty = "";
      this.Tooth1 = null;
      this.Tooth2 = null;
      this.ThirdPartyAmt = null;
      this.expirydate = null;
      this.Comments = "";
      this.SelectedCode = "";
      this.$refs.searchbox.inputValue = "";
    },
    EditPA: function (event) {
      var vm = this;
      var url = "/SaskHealthApi/Claims/PostEditDentalClaimServiceCode/";
      var params = {
        _: Date.now(),
        ServiceCodeID: vm.ServiceCodeId,
        ServiceID: vm.AppServiceID,
        Qty: vm.Qty, //"ServiceDate": vm.ServiceDate,
        Tooth1: vm.Tooth1,
        Tooth2: vm.Tooth2,
        Comments: vm.Comments,
        ServiceCode: vm.SelectedCode.servicecode,
        ServiceCodeDesc: vm.SelectedCode.servicedesc,
        ServiceFee: vm.ServiceFee,
        ClaimRequestNo: vm.ClaimRequestNo,
        ThirdPartyAmt: vm.ThirdPartyAmt,
        ExpiryDate: vm.ExpiryDate,
        PriorApprovalNo: vm.PriorApprovalNo,
        AssessedAmt: vm.AssessedAmt,
      };
      axios({
        method: "post",
        url: url,
        headers: {
          Authorization: "Bearer " + vm.$store.getters.GetAccessToken,
        },
        data: params,
      })
        .then(function (response) {
          if (response.status == 200) {
            vm.showModal = true;
            vm.succeeded = true;
            vm.Msg = "Service Code successfully updated.";
            //vm.ClaimRequestNo = response.data;
            console.log(response.data);
            // if (response.data.succeeded)
            // {
            //       vm.showModal =true;
            //       vm.succeeded = true;
            //       vm.Msg= "Service Code successfully updated";
            // }
          }
        })
        .catch(function (error) {
          if (error.response) {
            //console.log(error.response.data);
            //console.log(error.response.status);
            if (error.response.status == 500) {
              vm.succeeded = false;
              vm.Msg = "System Error; service code is not successfully saved.";
              vm.showModal = true;
            }
            //console.log(error.response.headers);
          }
          console.log(error);
        });
    },
    GetTotalSCodes() {
      var vm = this;
      console.log("Before get At total = " + this.ClaimRequestNo);
      if(this.ClaimRequestNo != null)
      {
        console.log("ClaimRequestNo ID at GET Total SC= " + this.ClaimRequestNo);
          var params = new URLSearchParams();
          params.append("ClaimId", this.ClaimRequestNo);
          axios
            .get("SaskHealthApi/Claims/GetToalScodes", {
              headers: { Authorization: "Bearer " + localStorage.access_token },
              params,
            })
            .then(function (response) {
              //console.log(response.data);
              vm.totalScodes = response.data;
              console.log(vm.totalScodes)
            })
            .catch(function (er) {
              console.log(er);
            });
      }
    },
    AddPA: function (event) {
      var vm = this;
      vm.GetTotalSCodes();
      if(vm.totalScodes < 40)
      {
      var url = "/SaskHealthApi/Claims/PostDentalClaimServiceCode/";
      var params = {
        _: Date.now(),
        HSN: vm.HSN,
        ProviderNo: vm.ProviderNo,
        ClaimTypeID: vm.ClaimTypeID,
        ClinicNo: vm.ClinicNo,
        ServiceID: vm.AppServiceID,
        ServiceDate: vm.ServiceDate,
        Qty: vm.Qty,
        Tooth1: vm.Tooth1,
        Tooth2: vm.Tooth2,
        Comments: vm.Comments,
        ServiceCode: vm.SelectedCode.servicecode,
        ServiceCodeDesc: vm.SelectedCode.servicedesc,
        ServiceFee: vm.ServiceFee,
        ClaimRequestNo: vm.ClaimRequestNo,
        ThirdPartyAmt: vm.ThirdPartyAmt,
        ExpiryDate: vm.ExpiryDate,
        PriorApprovalNo: vm.PriorApprovalNo,
      };
      axios({
        method: "post",
        url: url,
        headers: {
          Authorization: "Bearer " + vm.$store.getters.GetAccessToken,
        },
        data: params,
      })
        .then(function (response) {
          if (response.status == 200) {
            vm.ClaimRequestNo = response.data;
            console.log('After Add Claim id= ' + vm.ClaimRequestNo);
            if (vm.ClaimRequestNo != null) {
              vm.showModal = true;
              vm.succeeded = true;
              vm.Msg = "Service Code successfully added";
              vm.GetTotalSCodes();
            }
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status == 500) {
              vm.succeeded = false;
              vm.Msg = "Network Error, please contact system admin for more detail.";
              vm.showModal = true;
            }
          }
          console.log(error);
        });
      }
    },
    AddEditPA: function (event) {
      var vm = this;
      this.$v.$touch();
      //console.log(vm.SelectedCode)
      //console.log(vm.ServiceCode);
      //this.$refs.searchbox.clear();
      //console.log(this.$refs.searchbox)
      //this.ClrForm()
      console.log(vm.ServiceCodeId);
      if (!this.$v.$invalid) {
        //console.log('t')
        if (vm.ServiceCodeId != null) {
          this.EditPA();
        } else {
          this.AddPA();
        }
      }
    },
    Exit: function (event) {
      this.$root.$emit("bv::hide::modal", "modal-PA", "#btnShow");
      this.$emit("ServiceCodeDone", this.ClaimRequestNo);
    },
    Go() {
      this.$router.push("/DPEBB/MainHome");
    },
    Show() {
      this.showModal = true;
    },
    GetServiceCodes() {
      var vm = this;
      var params = new URLSearchParams();
      params.append("ServiceID", this.AppServiceID);
      vm.counter++;
      vm.loading =true;
      axios
        .get("SaskHealthApi/Codes/GetServiceCode", {
          headers: { Authorization: "Bearer " + localStorage.access_token },
          params,
        })
        .then(function (response) {
          vm.ServiceCodes = response.data; 
          // vm.ServiceCodes.sort(function(a,b){return a.cdss-b.cdss});
          _.forOwn(vm.ServiceCodes, function(value, key) {
              _.map(value, function(item) {
                if(value['cdss'] == true)
                {
                  // value['eff']= "NA";            
                  // value['exp']= "NA"; 

                  value['eff']= moment(value['eff'],"YYYY-MM-DD").format('YYYY/MM/DD');            
                  value['exp']= moment(value['exp'],"YYYY-MM-DD").format('YYYY/MM/DD');


                }
                else
                {
                  value['eff']= moment(value['eff'],"YYYY-MM-DD").format('YYYY/MM/DD');            
                  value['exp']= moment(value['exp'],"YYYY-MM-DD").format('YYYY/MM/DD'); 
                }
             });            
          });
          //console.log(vm.ServiceCodes)
        })
        .catch(function (er) {
          console.log(er);
        }).then(function()
        {
             vm.loading =false;
        });
    },
    ValidateTooth1Null() {
      if (this.Tooth1 == null || this.Tooth1 == "") {
        if (this.Tooth2 != null && this.Tooth2 != "") return false;
        else return true;
      } else {
        return true;
      }
    },
    ValidateTooth2() {
      //console.log('val: 2 Tooth 1 '+this.Tooth1)
      if (this.Tooth1 != null && this.Tooth1 != "") {
        if (
          this.Tooth2 != null &&
          this.Tooth2 != "" &&
          this.Tooth2 == this.Tooth1
        )
          return false;
        else return true;
      } else {
        return true;
      }
    },
    ValidateTooth1() {
      //console.log('val: 1 Tooth 1 '+this.Tooth1)
      if (this.Tooth1 == null || this.Tooth1 == "") {
        //console.log('com Value:'+this.Comments)
        //  console.log('com Value : '+this.Comments + 'Tooth2 Val='+this.Tooth2)
        if (
          this.Comments === null ||
          this.Comments === "" ||
          this.Tooth2 === null ||
          this.Tooth2 === ""
        ) {
          // console.log (this.Comments)
          //console.log('at 1 com: true com&tooth2 values : '+this.Comments + this.Tooth2)
          return true;
        } else if (this.Tooth2 !== null || this.Tooth2 !== "") {
          //console.log(this.Tooth2+ 'at 1: False ')
          return false;
        } else {
          //console.log('at 1: false')
          return false;
        }
      } else {
        //console.log('at 1: true')
        return true;
      }
    },
    ValidateComments() {
      if (this.Comments != null && this.Comments != "") {
        if (this.Tooth1 == null || this.Tooth1 == "") {
          return false;
        } else if (this.Tooth2 == null || this.Tooth2 == "") return false;
        else {
          return true;
        }
      } else {
        //console.log('good to go')
        return true;
      }
    },
    ValAssessedAmt() {
      if (this.SelectedClaimStatusID === 4 && this.ClaimInfo.CanOverride) {
        if (this.AssessedAmt == null || this.AssessedAmt == "") {
          return false;
        } else return true;
      } else return true;
    },
  },
  created: function () {
    //console.log(' Can Override = ' + this.ClaimInfo.CanOverride)
    //console.log(' Claimstatus = ' + this.ClaimInfo.SelectedID)
    this.AppServiceID = this.$store.getters.GetDentalID;
    this.dateFormat = this.$store.getters.GetDateFormat;
    this.HSN = this.ClaimInfo.HSN;
    this.ProviderNo = this.ClaimInfo.ProviderNo;
    this.ClinicNo = this.ClaimInfo.ClinicNo;
    this.ClaimRequestNo = this.ClaimInfo.ClaimRequestNo;
    if(this.ClaimRequestNo !== null)
    {
      this.GetTotalSCodes();
    }
    this.ClaimStatusId = this.ClaimInfo.StatusID;
    this.SelectedClaimStatusID = this.ClaimInfo.SelectedID;
    this.ClaimTypeID = this.ClaimInfo.ClaimTypeID;
   
    if (this.ClaimTypeID != undefined && this.ClaimTypeID === 1) {
      //console.log('sss' + this.ServiceCodeInfo.PriorApprovalNo)
      this.PriorApprovalNo = this.ServiceCodeInfo.PriorApprovalNo;
      
    }
    if (
      this.SelectedClaimStatusID != undefined &&
      this.SelectedClaimStatusID === 4
    ) {
      //console.log('Assessed Amount = ' + this.ServiceCodeInfo.AssessedAmt)
      this.AssessedAmt = this.ServiceCodeInfo.AssessedAmt;
    }
    if (this.ServiceCodeInfo.comments != undefined) {
      this.Comments = this.ServiceCodeInfo.comments;
      //console.log('Comment through Edit val' + this.Comments);
    }
    if (this.ServiceCodeInfo.expirydate != undefined) {
      this.ExpiryDate = this.ServiceCodeInfo.expirydate;
    }
    //console.log(' Desc ' + this.ServiceCodeInfo.description)
    //console.log(' Code =  ' +this.ServiceCodeInfo.servicecode)
    if (
      this.ServiceCodeInfo.description != undefined &&
      this.ServiceCodeInfo.servicecode != undefined
    ) {
      //console.log(' here at bind')
      // this.ServiceCode=this.ServiceCodeInfo.description;
      //this.SelectedCode ={"servicecode": this.ServiceCodeInfo.servicecode , "servicedesc": this.ServiceCodeInfo.description  }
      this.SelectedCode = {
        servicecode: this.ServiceCodeInfo.servicecode,
        servicedesc: this.ServiceCodeInfo.description,
      };
    }
    // if(this.ServiceCodeInfo.servicecode !=undefined)
    // {
    //     console.log(this.ServiceCodeInfo.servicecode);
    //     this.ServiceCodeId=this.ServiceCodeInfo.servicecode;
    // }
    if (
      this.ServiceCodeInfo.servicecodeid != undefined ||
      this.ServiceCodeInfo.servicecodeid != null
    ) {
      //console.log(this.ServiceCodeInfo.servicecodeid);
      this.btnName = "Edit Service Code";
      this.saveIcon = "far fa-edit";
      this.Note = "";
      this.ServiceCodeId = this.ServiceCodeInfo.servicecodeid;
    }
    if (this.ServiceCodeInfo.servicedate != undefined) {
      this.ServiceDate = this.ServiceCodeInfo.servicedate;
    }
    if (this.ServiceCodeInfo.servicefee != undefined) {
      this.ServiceFee = this.ServiceCodeInfo.servicefee;
    }
    if (this.ServiceCodeInfo.qty != undefined) {
      this.Qty = this.ServiceCodeInfo.qty;
    }
    if (this.ServiceCodeInfo.thirdpartyamt != undefined) {
      this.ThirdPartyAmt = this.ServiceCodeInfo.thirdpartyamt;
    }
    if (this.ServiceCodeInfo.tooth1 != undefined) {
      this.Tooth1 = this.ServiceCodeInfo.tooth1;
    }
    if (this.ServiceCodeInfo.tooth2 != undefined) {
      this.Tooth2 = this.ServiceCodeInfo.tooth2;
    }

    if(this.PriorApprovalNo != undefined && this.PriorApprovalNo != null  &&  this.PriorApprovalNo != '')
    {
       if (this.ClaimTypeID != undefined && this.ClaimTypeID === 1) {
       
       this.GetPriorAprovals(1)
       }
    }

  },
  mounted: function () {
    this.$nextTick(function () {
      var vm = this;
      vm.GetServiceCodes();
      if (
        this.ServiceCodeInfo.description != undefined &&
        this.ServiceCodeInfo.servicecode != undefined
      ) {
        this.$refs.searchbox.inputValue = this.ServiceCodeInfo.description;
        // this.ServiceCode=this.ServiceCodeInfo.description;
        //this.SelectedCode ={"servicecode": this.ServiceCodeInfo.servicecode , "servicedesc": this.ServiceCodeInfo.description  }
      }
    });
  },
  validations() {
    return {
      Qty: {
        required,
        val: (value) => value < 1000 && value != 0,
        numeric,
      },
      ServiceFee: {
        required,
        fee,
      },
      ThirdPartyAmt: {
        fee,
      },
      AssessedAmt: {
        fee,
        val: (value) => this.ValAssessedAmt(),
      },
      SelectedCode: {
        required,
      },
      Tooth2: {
        needValue: (value) => this.ValidateTooth2(),
        T1Check: (value) => this.ValidateTooth1Null(),
        val: (value) => value < 99,
        //numeric
      },
      Tooth1: {
        needValue: (value) => this.ValidateTooth1(),
        val: (value) => value < 99,
      },
      Comments: {
        needValue: (value) => this.ValidateComments(),
        commentsReg,
      },
      PriorApprovalNo: {
        numeric,
        Panumber,
      },
    };
  },
};
</script>
<style scoped>
/* .servdatapick >>> .datepickercss {
  /* width: 100%;
  height: 2rem; 
} */
</style>